/**
 * The card authorization running on this page, if any.
 *
 * One authorization per session per page: a double tap or a second Authorize
 * press joins the running attempt instead of starting another (usePayments).
 * Cancel marks it cancelled so its waits stop (useCancelAttempt). Session
 * rehydration leaves the payment step alone while one runs (SessionContext).
 *
 * Its own module so SessionContext can ask without importing usePayments,
 * which imports SessionContext.
 */
let active = null;

/** @returns {{ sessionUid: string, cancelled: boolean, promise: Promise|null } | null} */
export function getActivePreauth() {
  return active;
}

export function setActivePreauth(attempt) {
  active = attempt;
}

export function clearActivePreauth(attempt) {
  if (active === attempt) active = null;
}

/** Whether this page is running an authorization (for this session, if given). */
export function isPreauthActive(sessionUid) {
  return Boolean(active && !active.cancelled
    && (sessionUid == null || active.sessionUid === sessionUid));
}

/** Stop waiting on the authorization in progress (the driver cancelled). */
export function abortActivePreauth() {
  if (active) active.cancelled = true;
}

/** Test seam. */
export function __resetPreauthForTests() {
  active = null;
}
